import { styled } from '@mui/material';
import { Avatar } from 'shared/mui/Avatars';

export const AvatarStyled = styled(Avatar)(({ theme }) => ({
  background: theme.palette.primary.dark,
  color: theme.palette.common.white,
  cursor: 'pointer',
  width: '24px',
  height: '24px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
}));
